<template>
  <PullRefresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
    <div
      :class="$style.pageBox"
      :style="{ backgroundImage: `url(${cdn.CDN_URL_1}/box_648/648PageBgNew.jpeg)` }"
    >
      <div  :class="$style.playGamePart">
        <div :class="$style.partLeft">在玩</div>
        <div :class="$style.partRight">
          <img v-for="item in playGameList" :key="item.appkey" @click="() => onClickPlayGame(item)"
            :src="item.gameIcon" alt="" :class="$style.gameIcon" />
          <p v-if="playGameList.length == 0" :class="$style.emptyDesc">暂无在玩游戏</p>
        </div>
      </div>

      <!-- 未开始 0 -->
      <div
        v-if="pageData.activeStatus == 0"
        :class="$style.gamePlace"
        :style="{ backgroundImage: `url(${cdn.CDN_URL_1}/box_648/648box.png)` }"
      >
        <div :class="$style.nativeStatus">
          活动将于{{ pageData.startTime }} 开始
        </div>
      </div>

      <!-- 进行中 1 -->
      <template v-if="pageData.activeStatus == 1">
        <div
          :class="$style.gamePlace"
          @touchmove.stop
          @touchend.stop
          :style="{ backgroundImage: `url(${cdn.CDN_URL_1}/box_648/648box.png)` }"
        >
          <!-- 游戏会场 -->
          <List
            v-model="gameListLoading"
            :finished="gameListFinished"
            finished-text=""
            :class="$style.gamePlaceList"
            @load="onLoadGameList"
          >
              <div
                v-for="game in pageData.games"
                :key="game.gameId"
              >
                <div v-if="game.gifts && game.gifts.length > 0" :class="`${$style.gameBox} ${$style.boxBg}`" :id="game.gameId">
                  <img :src="game.logo" alt="" :class="$style.icon" />
                  <div :class="$style.info">
                    <div style="display: flex;margin-bottom: 8px;">
                      <p :class="$style.name" style="max-width: 90px;">{{ game.appName }}</p>
                      <p v-if="game.tag" :class="$style.tag">{{ game.tag }}</p>
                    </div>
                    <p :class="$style.giftValue">{{ game.giftValue }}</p>
                  </div>
                  <button
                    :class="$style.download"
                    @click="onGoGameDetail({ ...game, type: 1 })"
                  >
                    下载游戏
                  </button>
                </div>
                <div
                  v-for="gift in game.gifts || []"
                  :key="gift.welfareId"
                  :class="$style.giftBox"
                >
                  <img :src="gift.welfareIcon" alt="" :class="$style.icon" />
                  <div :class="$style.info">
                    <p :class="$style.giftName">{{ gift.giftName }}</p>
                    <p :class="$style.giftInfo">
                      {{ gift.giftDesc }}
                    </p>
                  </div>
                  <div>
                    <button :class="`${$style.get} ${gift.receiveStatus?$style.disableButton : null}`" 
                      @click="onGetGift({...gift, gameId: game.gameId, appName: game.appName})">
                      {{ gift.receiveStatus ? "已" : "" }}领取
                    </button>
                    <p :class="$style.type">{{ gift.refresh }}</p>
                  </div>
                </div>
              </div>
          </List>
        </div>
        <div class="tips fs_14 mb_18 mt_14 text_center" style="color: #FFED87">
          <p class="mb_12">温馨提示：</p>
          <p>该活动创角奖励与盒子内其余活动创角奖励不共享</p>
        </div>
      </template>

      <!-- 已结束 2 -->
      <div
        v-if="pageData.activeStatus == 2"
        :class="$style.gamePlace"
        :style="{ backgroundImage: `url(${cdn.CDN_URL_1}/box_648/648box.png)` }"
      >
        <div :class="$style.nativeStatus">活动已结束</div>
      </div>

      <!-- 弹窗 -->
      <div :class="$style.dialog" v-if="dialogVisible">
        <header>
          <span>系统提示</span>
          <img
            :src="`${cdn.CDN_URL}/packet/close.png`"
            alt=""
            :class="$style.close"
            @click="dialogVisible = false"
          />
        </header>
        <main>
          <!-- 弹窗类型 不在活动时间范围内 -->
          <div v-if="dialogType === 0" style="margin: 20px 0 30px">
            <div :class="$style.dialogTitle">不满足领取条件</div>
            <p style="text-align: center">
              您首次进入该游戏时间不在活动时间范围内
            </p>
            <p style="text-align: center">无法领取该礼包</p>
            <div :class="$style.btnGroup">
              <button :class="`${$style.sureBtn}`" @click="dialogVisible = false">
                我知道了
              </button>
            </div>
          </div>
          <div v-if="dialogType === 1" style="margin: 20px 0 30px">
            <div :class="$style.dialogTitle">未查询到游戏记录</div>
            <p style="text-align: center">活动时间内下载游戏并创角</p>
            <p style="text-align: center">即可领取该礼包</p>
            <div :class="$style.btnGroup">
              <button
                :class="`${$style.sureBtn}`"
                @click="onGoGameDetail({ type: 2 })"
              >
                下载游戏
              </button>
            </div>
          </div>
          <!-- 弹窗类型 充值进度 -->
          <div v-if="dialogType === 2" style="margin: 20px 0 30px">
            <div :class="$style.dialogTitle">不满足领取条件</div>
            <p style="text-align: center">
              {{ selectGift.drawRefresh === 1 ? '活动期间' : '今日' }}在游戏内充值{{ this.curGiftInfo.targetAmount }}元
            </p>
            <p style="text-align: center">即可领取该礼包</p>
            <div :class="$style.progress">
              <p :class="$style.text">当前进度</p>
              <p
                :class="$style.percentage"
                :style="{ width: percentage + '%' }"
              ></p>
              <p
                v-if="percentage < 100"
                :class="$style.amount"
                :style="{ left: (percentage == 0 ? 3 : percentage) + '%' }"
              >
                {{ this.curGiftInfo.amount }}
              </p>
              <p :class="$style.typeValue">{{ this.curGiftInfo.targetAmount }}</p>
            </div>
            <div :class="$style.btnGroup">
              <button
                @click="onGoGameDetail({ type: 3 })"
                :class="$style.sureBtn"
              >
                去完成
              </button>
            </div>
          </div>
          <!-- 弹窗类型 领取成功 -->
          <div v-if="dialogType === 3" style="margin: 20px 0 30px">
            <div :class="$style.dialogTitle">领取成功</div>
            <p style="text-align: center">礼包码已存放在</p>
            <p style="text-align: center">【我的】—【我的礼包】—【活动礼包】</p>
            <div :class="$style.btnGroup">
              <button :class="`${$style.sureBtn}`" @click="onGoGiftDetail">
                查看礼包码
              </button>
            </div>
          </div>
          <!-- 弹窗类型 礼包码错误 -->
          <div v-if="dialogType === 4">
            <p style="text-align: center">兑换码生成错误，</p>
            <p style="text-align: center">请联系客服领取备用码</p>
            <div :class="$style.btnGroup">
              <button @click="onRelationServer" :class="$style.sureBtn">
                联系客服
              </button>
            </div>
          </div>
        </main>
      </div>
      <div :class="$style.mask" v-if="dialogVisible"></div>
    </div>
  </PullRefresh>
</template>

<script>
import {
  setPageTitle,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
  toLogin,
  getUserInfo,
  signInEventTrack
} from "@/bridge/AppJsBridge";
import { getCookie, pageLoseTips } from "@/libs/utils";
import { inithandler } from "@/bridge/jsBridge";
import { getGamePlaceListApi, getWelfareApi, getPlayGamePlaceListApi } from "@/apis/wxActivity";
import { CDN_URL_1, CDN_URL } from "@/config";
import { PullRefresh, List, Cell } from "vant";
import { burnPoint } from "@/apis/heziShare";
import { queue } from "../../libs/queue.request";

const pageParams = {
  current: 1,
  size: 20
}

export default {
  data() {
    return {
      cdn: { CDN_URL_1, CDN_URL },
      pageTitle: "活动页面",
      gameInfo: { appName: "", logo: "", tags: [] },
      cookie: null,
      activeId: null,
      gameId: null,
      dialogVisible: false,
      dialogType: 0,
      dialogTitle: [
        "不满足领取条件",
        "不满足领取条件",
        "不满足领取条件",
        "领取成功",
        "提示",
      ],
      pageData: {
        games: [],
        activeStatus: null,
      },
      percentage: 20,
      curGiftInfo: {},
      token: "",
      isLoading: false,
      gameListLoading: false,
      gameListFinished: false,
      pageParams: pageParams,
      selectGift:{},
      reqQueue: queue(),
      playGameList:[]
    };
  },
  components: { PullRefresh, List },
  computed: {
    gameNames() {
      let str = "";
      if (this.pageData.games && this.pageData.games.length > 0) {
        for (const game of this.pageData.games) {
          if (game.appName) {
            str += game.appName + "、";
          }
        }
      }
      return str.slice(0, -1);
    },
  },
  watch: {
    cookie(value, oldValue){
      if (!oldValue && value && !getCookie()) {
        this.reqQueue.run(value);
      }
    },
  },
  created() {
    inithandler();
    this.reqQueue.create();
    this.setHeaderContent();
    this.initData();
    try {
      signInEventTrack(data => {
        this.cookie = JSON.parse(data);
      })
    } catch (error) {
      //
    }
  },
  activated() {
    setRightTxt('活动规则');
    if (this.pageData && this.pageData.activeName) {
      setPageTitle(this.pageData.activeName);
    }
  },
  methods: {
    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event)
      const params = {
        ...data,
      }
      if (!this.cookie) {
        console.log("数据上报异常", data.event,"转为补充数据上报")
        this.reqQueue.add(burnPoint,params)
        return
      }
      console.log("正常数据上报", data.event)
      burnPoint({
        ...this.cookie,
        ...params,
      }).catch(err => console.log(err));
    },
    
    // 页面初始化数据
    async initData() {
      this.pageParams = pageParams;
      const { history } = this.$router;
      const { activeId } = history.current.query;
      if (!activeId || isNaN(activeId)) {
        pageLoseTips(this.$toast);
        return;
      }
      this.activeId = activeId;
      
      // 获取登录态
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      this.getAppToken();
    },
    getAppToken(){
      if(getCookie("token")){
        localStorage.setItem('token', getCookie("token"));
        this.getMainList(true);
        this.getPlayGameList(this.activeId);
      }else{
        getUserInfo(userInfo => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            localStorage.setItem('token', Info.token);
          }
          this.getMainList(true);   
          this.getPlayGameList(this.activeId);
        });
      }
    },
    // 设置顶部内容
    setHeaderContent(){
      setRightTxtColor("#ff6600");
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 648,
            activeRule: this.pageData.activeRule,
          },
        });
        this.eventTrack({
          event: 'activity_rule',
          event_field:JSON.stringify({ activity_name: this.pageData.activeName,activity_id: this.activeId}),
        })
      });
    },

    getPlayGameList(activeId){
      getPlayGamePlaceListApi({activeId}).then(res => {
        const { data } = res;
        this.playGameList = data;
      })
    },
    // 下拉刷新
    async onRefresh() {
      // await this.initData();
      // setTimeout(() => {
      //   this.isLoading = false;
      // }, 500);
      // refreshing - isLoading
      // finished - gameListFinished
      // loading - gameListLoading

      this.gameListFinished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.gameListLoading = true;
      this.onLoadGameList();
    },
    onLoadGameList(){
      setTimeout(() => {
        if (this.isLoading) {
          this.pageData = {
            games: [],
            activeStatus: this.pageData.activeStatus,
          };
          this.isLoading = false;
        }
        this.getMainList();
      }, 1000);
    },
    // 获取数据
    getMainList(isInit=false) {
      getGamePlaceListApi({
        activeId: this.activeId,
        ...this.pageParams
      }).then((res) => {
        this.gameListLoading = false;
        setPageTitle(res.data.activeName);
        if (isInit) {
          this.eventTrack({
            event: 'activity_page',
            event_field:JSON.stringify({ activity_name: res.data.activeName,activity_id: this.activeId})
          });
        }
        if (!res.data.games ||res.data.games.length < this.pageParams.size) {
          this.gameListFinished = true;
        }else{
          this.gameListFinished = false;
          this.pageParams = {
            ...this.pageParams,
            current: this.pageParams.current + 1,
          };
        }

        if (res.data.current == 1) {
          this.pageData = res.data;
        }else{
          if (!res.data.games) {
            return
          }
          this.pageData = {
            ...res.data,
            games:[...this.pageData.games,...res.data.games]
          };
        }
      }).catch( (error) => {
        let errorInfo = error.response;
        const {data} = errorInfo;
        if (data && data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity");
        }
      })
    },
    // 领取礼包
    onGetGift(gift) {
      this.selectGift = gift;
      if (gift.receiveStatus) {
        this.dialogVisible = true;
        this.dialogType = 3;
        return;
      }

      this.eventTrack({
        event: 'activtiy_gift_get',
        event_field:JSON.stringify({ 
          activity_name: this.pageData.activeName,
          activity_id: this.activeId,
          gift_id: gift.giftId,
          gift_name: gift.giftName,
          menu_type:gift.receiveStatus,
        }),
        appName: gift.appName,
        appkey: gift.gameId
      });
      
      const params = {
        activeId: this.activeId,
        welfareId: gift.welfareId,
      }
      getWelfareApi(params).then(res => {
        if (!res.data) {
          return;
        }else{
          let event = 'activity_gift_get_pop';
          let eventField = {
            activity_name: this.pageData.activeName,
            activity_id: this.activeId,
            gift_id: gift.giftId,
            gift_name: gift.giftName
          };
          const { hasComplete, hasReceive, taskType, amount, targetAmount, gameId} = res.data;
          this.curGiftInfo = res.data;
          this.dialogVisible = true;
          this.gameId = gameId;
          // 不满足条件
          if (!hasComplete && !hasReceive) {
            // 0-账号在该游戏的首次进入游戏时间不在活动时间范围内 1-账号在该游戏无进入游戏记录 2-充值金额达X元
            this.dialogType = taskType;
            event = 'activity_gift_failure_pop';
            eventField.failure_type = taskType;
            if (taskType == 2) {
              this.percentage = Math.round(100*(amount/targetAmount));
            }
          }
          // 领取成功
          if (hasComplete && hasReceive){
            this.getMainList(true);
            this.dialogType = 3;
            eventField.get_result = 1;
          }
          // 生成错误
          if (hasComplete && !hasReceive){
            this.getMainList(true);
            this.dialogType = 4;
            eventField.get_result = 2;
          }
          this.eventTrack({
            event,
            event_field:JSON.stringify(eventField),
            appName: gift.appName,
            appkey: gift.gameId
          });
        }
      })
    },
    // 游戏详情
    onGoGameDetail({ gameId,appName, type }) {
      if (type === 1) {
        this.eventTrack({
          event: 'activity_game_scan',
          event_field:JSON.stringify({ activity_name: this.pageData.activeName,activity_id: this.activeId}),
          appName: appName,
          appkey: gameId
        })
      }
      if (type === 2) {
        // 下载游戏
        this.eventTrack({
          event: 'activity_pop_game_download',
          event_field:JSON.stringify({ 
            activity_name: this.pageData.activeName,
            activity_id: this.activeId,
            gift_id: this.selectGift.giftId,
            gift_name: this.selectGift.giftName
          }),
          appName: this.selectGift.appName,
          appkey: this.selectGift.gameId
        })
      }
      if (type === 3) {
        // 去完成
        this.eventTrack({
          event: 'activity_pop_task_goto_finish',
          event_field:JSON.stringify({ 
            activity_name: this.pageData.activeName,
            activity_id: this.activeId,
            gift_id: this.selectGift.giftId,
            gift_name: this.selectGift.giftName
          }),
          appName: this.selectGift.appName,
          appkey: this.selectGift.gameId
        })
      }
      let extraParams = gameId;
      if (!extraParams) {
        extraParams = this.gameId;
      }
      const data = {
        routePath: "/main/game/GameDetailActivity",
        extraParams,
        fromPageType: 40,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
      this.dialogVisible = false;
    },
    // 礼包详情
    onGoGiftDetail() {
      this.eventTrack({
        event: 'activity_pop_code_scan',
        event_field:JSON.stringify({ 
          activity_name: this.pageData.activeName,
          activity_id: this.activeId,
          gift_id: this.selectGift.giftId,
          gift_name: this.selectGift.giftName
        }),
        appName: this.selectGift.appName,
        appkey: this.selectGift.gameId
      })
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: 3,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
      this.dialogVisible = false;
    },
    // 联系客服
    onRelationServer() {
      localStorage.setItem("648ActivityId", this.activeId);
      this.dialogVisible = false;
      this.$router.push({
        name: `box.customerService`,
      });
    },
    /**
     * 点击在玩游戏icon
     * @param {*} gameInfo 在玩游戏信息
     */
    onClickPlayGame(gameInfo){
      const { appkey } = gameInfo;
      this.onScrollPageLocation(appkey);
    },

    /**
     * 调整页面滚动到指定位置
     * @param {*} locationId 对应位置id
     */
    onScrollPageLocation(locationId){
      this.$nextTick(() => {
        setTimeout(() => {
          document.getElementById(locationId).scrollIntoView();
        }, 200);
      })
    },
  },
};
</script>

<style lang="scss" module>
.pageBox {
  width: 100%;
  min-height: 100vh;
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #070529;
  max-width: 375px;
  margin: auto;
  padding-top: 90px;
  overflow: auto;

  .playGamePart {
    display: flex;
    align-items: center;
    margin: 10px auto 14px;
    width: 94%;
    .partLeft{
      color: #ffffff;
      font-size: 16px;
      font-weight: 700;
      height: 64px;
      background: linear-gradient(0deg,#982ee0 0%, #bf4ee5 100%);
      border: 1px solid #94e1f8;
      writing-mode: vertical-lr;
      text-align: center;
      padding: 0 6px;
      margin-right: -4px;
      z-index: 1;
      letter-spacing: 5px;
    }
    .partRight{
      overflow-y: auto; 
      width: calc(100% - 32px);
      height: 59px;
      // background: radial-gradient(rgba(135,235,239,0.95) 0%);
      background: linear-gradient(to right,rgba(135,235,239,.65), rgba(134,29,222,0.65));
      border: 1px solid #94e1f8;
      border-radius: 3.33px;
      display: flex;
      align-items: center;
      padding-left: 4px;
      .gameIcon{
        width: 44px;
        margin: 0 8px 0 10px;
      }
      .emptyDesc{
        width: 100%;
        text-align: center;
        color: #ffffff;
      }
    }
  }
  .gamePlace {
    width: 93.5%;
    // height: calc(100vh - 185px);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 10px auto 20px;
    padding: 14px 0;

    .gamePlaceList{
      overflow: auto;
      height: calc(100vh - 210px);
    }
    .nativeStatus {
      color: #d2d7f1;
      position: relative;
      top: 240px;
      width: 90%;
      margin: 0 auto;
      text-align: center;
      font-size: 15px;
    }

    .gameBox,
    .giftBox {
      width: 92%;
      margin: 0 auto;
      height: 80px;
      align-items: center;
      justify-content: space-around;
      display: flex;
      padding: 0 8px;
      .icon {
        width: 48px;
        height: 48px;
      }
      .info {
        flex: 1;
        margin: 0 7px;
        .categoryNames {
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #ff7a2a;
          line-height: 12px;
        }
        .giftValue {
          font-size: 13px;
          font-weight: 400;
          text-align: left;
          color: #ffe000;
          line-height: 13px;
        }
        .tag{
          height: 16px;
          background: #e6dbf2;
          border-radius: 2px;
          font-size: 14px;
          font-weight: 500;
          color: #243e8a;
          line-height: 16px;
          display: inline-block;
          padding: 0 6px;
          margin-left: 5px;
        }
        .name {
          font-size: 16px;
          font-weight: 500;
          color: #75fff2;
          line-height: 16px;
        }
        .giftName {
          font-size: 13px;
          font-weight: 400;
          color: #75fff2;
          line-height: 13px;
          margin-bottom: 8px;
        }
        .giftInfo {
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #afafaf;
          line-height: 14px;
        }
      }
      .download {
        width: 82px;
        height: 30px;
        font-weight: 500;
        font-size: 15px;
        text-align: center;
        border: none;
        color: #fbffb9;
        background: #ff9002;
        border-radius: 4px;
      }
      .get {
        width: 65px;
        border: none;
        padding: 5px 0;
        background: #fff6ae;
        border-radius: 11.46px;
        font-size: 15px;
        font-weight: 500;
        text-align: center;
        color: #d82f38;
      }
      .disableButton{
        filter: grayscale(1);
      }
      .type {
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        color: #afafaf;
        margin-top: 8px;
      }
    }

    :last-child.giftBox{
      margin-bottom: 18px;
    }
    .boxBg {
      background: linear-gradient(#4a5197 0%, #3e317e 100%);
      border: 1px solid #37325b;
    }
  }
  .dialog {
    width: 320px;
    min-height: 200px;
    position: fixed;
    top: 32%;
    left: 0;
    right: 0;
    // bottom: 0;
    margin: auto;
    background-color: #ffffff;
    z-index: 100;
    border-radius: 4px;
    overflow: hidden;
    > header {
      display: flex;
      background: linear-gradient(90deg, #ff782c 0%, #ffb503 100%);
      font-size: 19px;
      color: #ffffff;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      height: 37px;
      .close {
        position: absolute;
        top: 8px;
        right: 10px;
        width: 16px;
        height: 16px;
      }
    }
    > main {
      text-align: center;
      padding: 20px 0 70px;
      .bt {
        font-size: 18px;
        font-weight: 700;
        color: #ff612c;
        margin-bottom: 30px;
        text-align: center;
      }
      p {
        width: 100%;
        margin: auto;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        > span {
          color: #ff612c;
        }
      }
      .hint {
        font-size: 13px;
        color: #666666;
      }
    }
    .btnGroup {
      position: absolute;
      bottom: 20px;
      display: flex;
      justify-content: center;
      width: 80%;
      left: 0;
      right: 0;
      margin: auto;
      > button {
        border: none;
        outline: none;
        width: 105px;
        height: 35px;
        font-size: 13px;
        border-radius: 35px;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        &:active {
          opacity: 0.8;
        }
      }
      .cancelBtn {
        background: #fff2f2;
        color: #fc5f5e;
        margin-right: 28px;
      }
      .sureBtn {
        background: #fd383c;
        color: #ffffff;
      }
    }
    .dialogTitle {
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      color: #ff612c;
      line-height: 27px;
      margin-bottom: 10px;
    }
    .dialogImg {
      // width: 68px;
      height: 54px;
    }
    .progress {
      height: 8px;
      // background: #d43e41;
      border-radius: 8px;
      border: 1.04px solid #c73534;
      width: 80%;
      margin: 20px auto 0;
      position: relative;
      .percentage {
        height: 7px;
        position: absolute;
        left: 1px;
        top: 0;
        bottom: 0;
        background: linear-gradient(#ff756a 0%, #ffb46b 100%);
        border-radius: 6px;
      }
      .text {
        font-size: 12px;
        color: #747474;
        font-weight: 500;
        position: absolute;
        top: -22px;
        width: auto;
        left: 0;
      }
      .amount {
        font-size: 12px;
        color: #c73534;
        font-weight: 500;
        position: absolute;
        top: 8px;
        width: auto;
        margin-left: -10px;
      }
      .amount::before,
      .typeValue::before {
        content: ".";
        position: absolute;
        top: -11px;
        left: 50%;
      }
      .typeValue {
        font-size: 12px;
        color: #c73534;
        font-weight: 500;
        position: absolute;
        right: -6px;
        top: 8px;
        width: auto;
      }
    }
    .giftDetailWrapper {
      max-height: 260px;
      overflow: auto;
    }
    .giftDetail {
      padding: 3px 12px;
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;
      // justify-content: space-between;
      .detailIcon {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        margin-left: 12px;
      }
      .infoBox {
        flex: 1;
        text-align: left;
      }
      .name {
        font-size: 14px;
        color: #fc5f5e;
        line-height: 20px;
      }
      .detail {
        font-size: 12px;
        color: #666666;
        line-height: 16px;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
  }
}
</style>
